/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 */

import { motorService } from '../../constants/apiRequest/requestConstants/endpoints';
import { isAnalyticsEnabled } from '../../constants/commonConstants';
import { sendAnalyticsEvent } from '../../helpers';
import { makeRequest } from '../../helpers/makeApiRequest';


export const postMotorQuote = async (motorQuoteData, props = {}) => {
  const quoteRequest = await makeRequest({
    method: 'POST',
    url: `${motorService}`,
    payload: motorQuoteData,
    history: props.history
  });

  if (isAnalyticsEnabled) {
    sendAnalyticsEvent(quoteRequest, 'insuranceEvent', 'Car');
  }
  return quoteRequest;
};
